import ProcessingAnimation from './ProcessingAnimation'

export default ProcessingAnimation
